import React, { PureComponent } from "react";
import AppConfig from "../config/appconfig.json";
import moment from "moment";
import $ from "jquery";

class NetsPaymentModule extends PureComponent {
    constructor(props) {
        super(props);

        const txnAmount = parseInt(props.txnAmount, 10);
        const txtAmountCent = txnAmount * 100;
        const strRequestForm = JSON.stringify(props.requestForm);
        //console.log('request form below');
        //console.log(strRequestForm);
        //console.log('props');
        //console.log(props);
        //console.log(props.isInvoicePayment);
        const isInvoicePayment = props.isInvoicePayment ? true : false;
        //console.log(isInvoicePayment);

        let secretKey = AppConfig.NETS_SECRET_KEY;
        let apiKey = AppConfig.NETS_API_KEY;
        let b2sTxnEndURL = AppConfig.NETS_b2sTxnEndURL;
        let s2sTxnEndURL = AppConfig.NETS_s2sTxnEndURL;
        let jsUrl = AppConfig.NETS_JS_URL;
        let envUrl = AppConfig.NETS_ENV_URL;

        if (AppConfig.NETS_IS_SANDBOX) {
            secretKey = AppConfig.NETS_UAT_SECRET_KEY;
            apiKey = AppConfig.NETS_UAT_API_KEY;
            envUrl = AppConfig.NETS_UAT_ENV_URL;
            jsUrl = AppConfig.NETS_UAT_JS_URL;
        }
        const merchantTxnRef = moment().format("YYYYMMDDHH:mm:ss.SS");
        const merchantTxnDtm = moment().format("YYYYMMDD HH:mm:ss.SSS");

        const netsMid = AppConfig.NETS_MERCHANT_ID;

        /**
         * Request Example
         * {
            "ss":"1", <Default>
            "msg":{
                    "txnAmount":"1000", <replace>
                    "merchantTxnRef":"20170605 10:26:51.98", <replace>
                    "b2sTxnEndURL":"https://sit2.enets.sg/MerchantApp/sim/b2sTxnEndURL.jsp", <replace>
                    "s2sTxnEndURL":"https://sit2.enets.sg/MerchantApp/rest/s2sTxnEnd",<replace>

                    "netsMid":"UMID_887770001", <replace>
                    "merchantTxnDtm":"20170605 10:26:51.989", <replace>

                    "submissionMode":"B", <default value1>
                    "paymentType":"SALE", < default value1>
                    "paymentMode":"",<default value1>
                    "clientType":"W", <default value1>
                    "currencyCode":"SGD", < default value2>
                    "merchantTimeZone":"+8:00", <default value2>
                    "netsMidIndicator":"U", <default value2>
                }
            }
        */
        const txnReq = {
            ss: "1",
            msg: {
                txnAmount: txtAmountCent,
                merchantTxnRef: merchantTxnRef,
                b2sTxnEndURL: b2sTxnEndURL,
                s2sTxnEndURL: s2sTxnEndURL,

                netsMid: netsMid,
                merchantTxnDtm: merchantTxnDtm,

                submissionMode: "B",
                paymentType: "SALE",
                paymentMode: "",
                clientType: "W", // To display NETS payment selection option page in a separate web page hosted at NETS server instead of displaying inline (div section) 
                // embedded in Merchant web page, change the clientType value to H
                currencyCode: "SGD",
                merchantTimeZone: "+8:00",
                netsMidIndicator: "U"
            }
        };

        sessionStorage.clear();
        sessionStorage.setItem(merchantTxnRef, strRequestForm);
        sessionStorage.setItem('TrxInv' + merchantTxnRef, isInvoicePayment);

        // console.log("sessionStorage");
        // console.log(strRequestForm);

        //console.log("transaction request");
        //console.log(txnReq);

        const strTxnReq = JSON.stringify(txnReq);
        const hmac = this.generateSignature(strTxnReq, secretKey);
        // console.log(hmac);

        this.state = {
            txnReq: strTxnReq,
            hmac: hmac,
            keyId: apiKey,
            netsEnvUrl: envUrl,
            netsJsUrl: jsUrl
        };
    }

    generateSignature(strTxnReq, strSecretKey) {
        const concatPayloadAndSecretKey = strTxnReq + strSecretKey;
        const hmac = this.hashSHA256ToBytes(concatPayloadAndSecretKey);
        return hmac;
    }

    hashSHA256ToBytes(input) {
        const crypto = require("crypto");
        const hash = crypto
            .createHash("sha256")
            .update(input)
            .digest("base64");
        return hash;
    }

    componentDidMount() {
        const $Script = require("scriptjs");
        $Script(
            [
                "https://code.jquery.com/jquery-1.12.4.min.js",
                this.state.netsEnvUrl,
                this.state.netsJsUrl
            ],
            function () {
                // console.log("loaded");
                $(document).ready(function () {
                    const txnReq = $("#txnReq").val();
                    const keyId = $("#keyId").val();
                    const hmac = $("#hmac").val();
                    //   console.log("('" + txnReq + "','" + hmac + "','" + keyId + "')");
                    window.sendPayLoad(txnReq, hmac, keyId);
                });
                $(document).ajaxComplete(function () {
                    if ($("#redirectForm #message").val() !== "") {
                        $("#redirectForm").submit();
                    }
                });
            }
        );
    }

    render() {
        return (
            <div>
                <input
                    type="hidden"
                    id="txnReq"
                    name="txnReq"
                    value={this.state.txnReq}
                />
                <input type="hidden" id="keyId" name="keyId" value={this.state.keyId} />
                <input type="hidden" id="hmac" name="hmac" value={this.state.hmac} />
                <div id="anotherSection">
                    <fieldset>
                        <div id="ajaxResponse" />
                    </fieldset>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
            </div>
        );
    }
}

export default NetsPaymentModule;



// WEBPACK FOOTER //
// ./src/components/NetsPaymentModule.js